import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from './consola/menu/app.menu.service';
import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { CONSTANTES, CONSTANTES_SESION } from './core/_util/services-util';
import { CoreService } from './core/_services/core.services';
import { AlertasService } from './core/_services/alerta.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html'
})
export class AppMainComponent implements OnInit {

    menuClick: boolean;
    menuButtonClick: boolean;
    topbarMenuButtonClick: boolean;
    topbarMenuClick: boolean;
    topbarMenuActive: boolean;
    activeTopbarItem: Element;
    layoutMode = 'overlay';
    sidebarActive: boolean;
    mobileMenuActive: boolean;
    darkMenu = false;
    isRTL = false;
    menuHoverActive: boolean;
    resetMenu: boolean;
    configActive: boolean;
    configClick: boolean;
    inputStyle = 'outlined';
    ripple = false;
    compactMode = true;

    // modales
    displayPanel: boolean = false;
    claveActual: string = '';
    claveCambio: string = '';
    claveRepeticion: string = '';
    pasoUno: Boolean = true;
    pasoDos: Boolean = false;

    username = sessionStorage.getItem(CONSTANTES_SESION.USERNAME);

    constructor(private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        private coreService: CoreService,
        private msj: AlertasService,
        private confirmationService: ConfirmationService,
        private router: Router) { }

    ngOnInit() {
        this.primengConfig.ripple = true;
    }

    dialogoContrasena() {
        this.displayPanel = true;
    }

    verificarClave() {
        const params = {
            name: this.username,
            password: this.claveActual
        }
        this.coreService.post(CONSTANTES.URI_LOGIN, params).subscribe(
            (response: any) => {
                this.cambiarPaso();
            },
            (err: any) => {
                this.msj.alerta('Clave incorrecta.');
            }
        );
    }

    cambiarPaso() {
        this.pasoUno = false;
        this.pasoDos = true;
    }

    confirmaSalida() {
        this.confirmationService.confirm({
            message: '¿Desea salir de la aplicación?',
            accept: () => {
                sessionStorage.clear();
                window.location.reload();
                this.router.navigate(["/login"]);
            }
        });
    }

    cambioClave() {
        if (this.claveCambio !== '') {
            if (this.claveRepeticion !== '') {
                if (this.claveCambio !== this.claveRepeticion) {
                    this.msj.alerta('La nueva clave asignada no coincide con la de verificación');
                } else {
                    const params = {
                        name: this.username,
                        password: this.claveCambio,
                        password_confirmation: this.claveRepeticion
                    };
                    this.coreService.putWithOutParam('/update-pw', params).subscribe(
                        (response: any) => {
                            this.msj.info('Cambio de clave realizado correctamente.');
                            this.displayPanel = false;
                        },
                        (err: any) => {
                            this.msj.error(err);
                        }
                    );
                }
            } else {
                this.msj.info('Debe ingresar la nueva clave nuevamente.');
            }
        } else {
            this.msj.info('Debe ingresar una nueva clave.');
        }
    }


    onWrapperClick() {
        if (!this.menuClick && !this.menuButtonClick) {
            this.mobileMenuActive = false;
        }

        if (!this.topbarMenuClick && !this.topbarMenuButtonClick) {
            this.topbarMenuActive = false;
            this.activeTopbarItem = null;
        }

        if (!this.menuClick) {
            if (this.isHorizontal()) {
                this.menuService.reset();
            }

            this.menuHoverActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.configClick = false;
        this.menuClick = false;
        this.menuButtonClick = false;
        this.topbarMenuClick = false;
        this.topbarMenuButtonClick = false;
    }

    onMenuButtonClick(event: Event) {
        this.menuButtonClick = true;

        if (this.isMobile()) {
            this.mobileMenuActive = !this.mobileMenuActive;
        }

        event.preventDefault();
    }

    onTopbarMobileMenuButtonClick(event: Event) {
        this.topbarMenuButtonClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;
        event.preventDefault();
    }

    onTopbarRootItemClick(event: Event, item: Element) {
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarMenuClick(event: Event) {
        this.topbarMenuClick = true;
    }

    onSidebarClick(event: Event) {
        this.menuClick = true;
        this.resetMenu = false;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRippleChange(event) {
        this.ripple = event.checked;
    }

    onToggleMenuClick(event: Event) {
        this.layoutMode = this.layoutMode !== 'static' ? 'static' : 'overlay';
        event.preventDefault();
    }

    isMobile() {
        return window.innerWidth <= 1024;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isHorizontal() {
        return this.layoutMode === 'horizontal';
    }

    isOverlay() {
        return this.layoutMode === 'overlay';
    }
}
